import { useCallback, useMemo } from "react";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import type { StatementAxisState } from "../../../../store/types/fieldsState.types.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import FieldConditionsPanel from "../common/FieldConditionsPanel.tsx";
import { getAxisConditionDimensions } from "../utils/statementColumns.ts";

const noLinkableConditions: ConditionField[] = [];

interface Props {
  axis: StatementAxisState;
  readonly: boolean;
  popupAnchorEl: HTMLElement | undefined;
  onClosePopup: () => void;
}

const AxisConditionsPanel = ({ axis, readonly, popupAnchorEl, onClosePopup }: Props) => {
  const dispatch = useAppDispatch();
  const { dimensions } = useBiCommonDataContext();
  const { field } = axis;

  const conditionDimensions = useMemo(() => getAxisConditionDimensions(dimensions), [dimensions]);

  const handleUpdateField = useCallback(
    (changes: Partial<FieldConfiguration>) =>
      dispatch(
        createFinancialStatementAction("updateAxis", {
          guid: field.config.guid,
          changes: { field: { ...field, config: { ...field.config, ...changes } } },
        })
      ),
    [dispatch, field]
  );

  return (
    <FieldConditionsPanel
      field={field}
      dimensions={conditionDimensions}
      globalConditions={noLinkableConditions}
      readonly={readonly}
      popupAnchorEl={popupAnchorEl}
      onClosePopup={onClosePopup}
      onUpdateField={handleUpdateField}
    />
  );
};

export default AxisConditionsPanel;
